import api from '../config/api';

class PincodeService {
  async checkServiceability(pincode) {
    const response = await api.post('/pincode/check', { pincode });
    return response.data;
  }
}

const pincodeService = new PincodeService();
export default pincodeService;
